import { ActionTree } from 'vuex'
import { NotificationType } from './types'
import { RootState } from '../types'
import { connectionService } from '@leapsight/styleguide'
import { NotificationsHelpers } from '@/helpers/mainExports'
export const actions: ActionTree<NotificationType, RootState> = {
  subscribe({ commit, dispatch }, session) {
    const userId = connectionService.getBusinessUserId()

    const topic = `com.magenta.notification.${userId}.inbox`

    function onevent(args) {
      dispatch('setUnreadNotifications')
      commit('newNotification', args[0])
      commit('setOneUnreadNewNotifications')
    }
    session
      .subscribe(topic, onevent, { match: 'exact' })
      .then(function(subscription) {
        const payload = {
          type: 'notification',
          action: 'inbox',
          subscription
        }
        commit('setSubscription', payload)
      })
  },
  removeNotificationsByIndex({ commit }, index) {
    commit('removeNotificationsByIndex', index)
  },
  async setUnreadNotifications({ commit }) {
    const unreadNotifications = await NotificationsHelpers.getUnreadNotifications()
    commit('setUnreadNotifications', unreadNotifications)
  }
}
